module.exports = __webpack_public_path__ + "static/media/Logo.d541ab13.png";